<template>
  <div>
    <!--搜索栏-->
    <searchBar
      :search-form="searchForm"
      btn-add
      status
      name
      @handleAdd="handleAdd"
      @handleSearch="getData"
    >
      <el-select
        v-model="searchForm.level"
        size="mini"
        clearable
        placeholder="党组类型"
      >
        <el-option label="委员会" :value="1"></el-option>
        <el-option label="支部" :value="2"></el-option>
      </el-select>
    </searchBar>

    <!--表格-->
    <el-table :data="tableData" border>
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="60"
      ></el-table-column>
      <el-table-column
        v-for="(item, index) in tableHeader"
        :key="index"
        :label="item"
        :prop="index"
        align="center"
      ></el-table-column>

      <el-table-column fixed="right" label="内容" align="center">
        <template slot-scope="scope">
          <el-button
            @click="showActivityContent(scope.row.content)"
            type="text"
            size="mini"
          >
            点击查看
          </el-button>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.row)" type="text" size="mini">
            编辑
          </el-button>
          <el-button
            @click="handleEnabled(scope.row)"
            type="text"
            :style="{ color: scope.row.status === 1 ? 'red' : '' }"
            size="mini"
          >
            {{ scope.row.status === 1 ? "禁用" : "启用" }}
          </el-button>
          <el-button
            @click="handleDelete(scope.row)"
            type="text"
            style="color:red"
            size="mini"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="block">
      <el-pagination
        class="pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="size"
        layout=" prev, pager, next, jumper, sizes"
        :total="totalElements"
      ></el-pagination>
    </div>

    <!--新增Dialog-->
    <el-dialog
      title="添加党组"
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="100px"
        label-suffix="："
        label-position="right"
        :status-icon="true"
      >
        <el-form-item label="名称" prop="name" label-width="100px">
          <el-input
            v-model="form.name"
            size="medium"
            placeholder="名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="党组类型" prop="level" label-width="100px">
          <el-select
            style="width:100%"
            v-model="form.level"
            size="mini"
            placeholder="选择党组类型"
          >
            <el-option label="委员会" :value="1"></el-option>
            <el-option label="支部" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="描述" label-width="100px" prop="description">
          <el-input
            v-model="form.description"
            size="medium"
            type="textarea"
            :rows="3"
            placeholder="党组描述信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogCancel">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Axios from "axios"
import apiUrl from "@/assets/http/apiUrl"
import { pick } from "lodash"
import { resetObject } from "@/utils"

const tableHeader = {
  name: "名称",
  description: "描述",
  statusName: "状态",
}

export default {
  name: "PartyGroup",
  data() {
    let Self = this

    // 表单验证
    let validate = (rule, value, callback) => {
      if (!!value) {
        this.$refs.form.validateField("checkPass")
        callback()
      } else {
        callback(new Error("数据填写不完整"))
      }
    }

    return {
      // 页面初始数据
      totalElements: 10,
      currentElements: 10,
      totalPages: 1,
      size: 10,
      page: 1,

      serverUrl: apiUrl.ServerUrl,

      // 搜索栏初始化
      searchForm: {
        name: "",
        status: "",
        level: "",
      },

      // 表头初始化
      tableHeader,

      // 表格数据
      tableData: [],

      // dialog可见性
      dialogFormVisible: false,

      // 新增表单
      form: {
        uid: "",
        name: "",
        level: "",
        description: "",
      },

      // 表单验证规则
      rules: {
        name: {
          required: true,
          trigger: "blur",
          message: "请输入名称",
        },
        level: {
          required: true,
          trigger: "blur",
          message: "请选择党组类型",
        },
        description: {
          required: true,
          trigger: "blur",
          message: "请输入基本信息描述",
        },
      },

      // 头像上传初始化
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
    }
  },
  methods: {
    /*图片预览
     * */
    getImgPreviewList(url) {
      let arr = new Array(this.serverUrl + url)
      return arr
    },

    /*请求数据
     * */
    getData() {
      this.request({
        url: "/manager/party/findPartyInfo",
        method: "get",
        params: {
          page: this.page,
          size: this.size,

          ...this.searchForm,
        },
      })
        .then(res => {
          this.size = res.data.data.size
          this.page = res.data.data.page
          this.totalElements = Number(res.data.data.totalElements)
          this.totalPages = res.data.data.totalPages
          this.currentElements = res.data.data.currentElements
          this.tableData = res.data.data.content
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*更改单页数据数量
     * */
    handleSizeChange(size) {
      this.size = size
      this.getData()
    },

    /*页码跳转
     * */
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },

    /*启用/禁用
     * */
    handleEnabled(rowData) {
      let status = rowData.status === 1 ? 2 : 1
      this.request({
        url: "/manager/party/updatePartyStatus",
        data: {
          uid: rowData.uid,
          status: status,
        },
        method: "post",
      })
        .then(res => {
          this.$message.success("操作成功")
          this.getData()
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    /*审核参加人员
     * */
    handleAudit(rowData) {
      this.currentActityUid = rowData.uid
      this.getVolunteers(this.currentActityUid)
    },

    /*编辑
     * */
    handleEdit(rowData) {
      this.form = {
        ...rowData,
      }

      this.dialogFormVisible = true
    },

    /*发布新闻
     * status
     *   3 发布
     *   4 屏蔽*/
    handlePublish(rowData, type) {
      let text = type === 2 || type === 4 ? "屏蔽" : "发布"
      this.$confirm("确认" + text + "?")
        .then(() => {
          this.request({
            url: "/manager/news/releaseOrShield",
            params: {
              uid: rowData.uid,
              status: type,
            },
            method: "post",
          })
            .then(res => {
              this.$message.success(text + "成功")
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch()
    },

    /*添加操作
     * */
    handleAdd() {
      this.dialogFormVisible = true
    },

    /*删除
     * */
    handleDelete(rowData) {
      this.$confirm("确认删除?")
        .then(() => {
          this.request({
            url: "/manager/party/deleteParty",
            params: {
              uid: rowData.uid,
            },
            method: "DELETE",
          })
            .then(res => {
              this.$message.success("删除成功")
              this.getData()
            })
            .catch(err => {
              this.$message.error(err.message)
            })
        })
        .catch()
    },

    /*dialog提交
     * */
    dialogConfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.request({
            url: "/manager/party/addOrUpdatePartyInfo",
            data: {
              ...this.form,
            },
            method: "post",
          })
            .then(res => {
              this.dialogFormVisible = false

              this.getData()
              resetObject(this.form)
              this.form.level = ""
            })
            .catch(err => {
              this.$message(err.message)
            })
        }
      })
    },

    /*dialog取消
     * */
    dialogCancel() {
      resetObject(this.form)
      this.form.level = ""

      this.center = {}
      this.dialogFormVisible = false
    },

    /*覆盖默认上传请求
     * */
    overwriteDefault(e) {
      let tmpFile = new FormData()
      tmpFile.append("file", e.file)
      this.file = tmpFile
      Axios.post(apiUrl.server + "/manager/upload/uploadPic", this.file, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
        .then(res => {
          if (res.data.status === "OK") {
            this.$message.success("上传成功")
            this.form.cover = res.data.data
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    uploadCancel() {
      this.dialogUploadVisible = false
      this.form = {}
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    // 准备富文本编辑器
    onEditorReady(editor) {},
    // 富文本编辑器 失去焦点事件
    onEditorBlur(editor) {},
    // 富文本编辑器 获得焦点事件
    onEditorFocus(editor) {},
    // 富文本编辑器 内容改变事件
    onEditorChange(editor) {
      this.form.conditions = editor.html
    },

    /*级联选择器
     * */
    // 处理小组/街道uid
    handleCascader(uids) {
      if (uids) {
        this.form.type = uids[0]
      }
    },

    showActivityContent(content) {
      this.dialogContentVisible = true
      this.activityContent = content
    },
  },
  mounted() {},
  beforeDestroy() {
    this.editor = null
    delete this.editor
  },
  created() {
    this.getData()
  },
}
</script>

<style scoped>
.bm-view {
  width: 100%;
  height: 300px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 200px;
  height: 150px;
  object-fit: cover;
  display: block;
}
</style>
